<template>
    <div class="mailing_settings_wrapper">
        <MailingSettingsHeader />
        <MailingSettingsBody />
    </div>
</template>

<script>
import MailingSettingsHeader from './MailingSettingsHeader.vue';
import MailingSettingsBody from './MailingSettingsBody.vue';
import { useMailingStore } from "@/stores/MailingStore";

export default {
    name: "MailingSettings",
    props: ['setIsSetting'],
    setup() {
        const mailingStore = useMailingStore();
        return {
            mailingStore
        }
    },
    components: {
        MailingSettingsHeader,
        MailingSettingsBody
    },
}
</script>

<style scoped>
    .mailing_settings_wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding-top: 45px;
        gap: 36px;
    }
</style>
